import SideBar from "./components/SideBar"
import { Box } from "@mui/material"
import { Outlet } from "react-router-dom"
import Notification from "./components/Notification"
import OrderSocketListener from "./helpers/OrderSocketListener"

const AppLayout = () => {
    return (
        <div style={{ display: 'flex' }}>
            {/* <OrderSocketListener /> */}
            <Box>
                <SideBar />
            </Box>
            <Box component="main" sx={{ flexGrow: 2 }}>
                {/* <Notification /> */}
                {<Outlet />}
            </Box>
        </div>
    )
}

export default AppLayout;